module.exports = __webpack_public_path__ + "static/img/20.2cfe30bf.webp";